import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import {
    GridRowModes,
    DataGrid,
    GridToolbarContainer,
    GridActionsCellItem,
    useGridApiContext,
    GridRowEditStopReasons,
} from '@mui/x-data-grid';
import { Grid } from '@mui/material'
import Pagination from '@mui/material/Pagination'
import Stack from '@mui/material/Stack'
import {
    randomCreatedDate,
    randomTraderName,
    randomId,
    randomArrayItem,
} from '@mui/x-data-grid-generator';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../components/Loader'
import { addFaq, editFaq, deleteFaq, faqList } from '../../actions/settings';

const roles = ['Market', 'Finance', 'Development'];
const randomRole = () => {
    return randomArrayItem(roles);
};

function EditToolbar(props) {
    const { setRows, setRowModesModel, faq } = props;
    const handleClick = () => {
        const id = randomId();
        setRows((oldRows) => [{ id, name: '', isNew: true }, ...faq.list,]);
        setRowModesModel((oldModel) => ({
            ...oldModel,
            [id]: { mode: GridRowModes.Edit, fieldToFocus: 'name' },
        }));
    };

    return (
        <GridToolbarContainer>
            <Button color="primary" style={{ color: "#442580", fontWeight: "bold" }} className="btn btn-primary btn-block merchantAddButton" startIcon={<AddIcon />} onClick={handleClick}>
                Add New
            </Button>
        </GridToolbarContainer>
    );
}



const FAQ = () => {
    const faq = useSelector((state) => state.faq)

    const [rows, setRows] = React.useState(faq?.list);
    const [rowModesModel, setRowModesModel] = React.useState({});
    const loaders = useSelector((state) => state.loader)
    const [filter, setFilter] = useState(0);
    const handleRowEditStop = (params, event) => {
        if (params.reason === GridRowEditStopReasons.rowFocusOut) {
            event.defaultMuiPrevented = true;
        }
    };
    const dispatch = new useDispatch();
    const [data, setData] = useState([])
    const [limit, setLimit] = useState(10)
    const [page, setPage] = useState(1)
    const [deleteIds, setDeleteIds] = useState([])

    useEffect(() => {
        setRows(faq?.list)
    }, [filter, faq])

    const setNewPage = (page) => {
        setPage(page)
        // setDeleteButton(false)
        // setDeleteIds([])

    }
    const updatePagination = (e) => {
        setLimit(e.target.value)
        setPage(1)
        // setDeleteButton(false)
        // setDeleteIds([])
    }
    useEffect(() => {
        const params = { page: page, limit: limit }
        dispatch(
            faqList(params, (res) => {
                setRows(faq?.list)

            }),
        )


    }, [limit, page, filter])


    const handleEditClick = (id) => {
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    };

    const handleSaveClick = (id) => {
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
    };

    const handleDeleteClick = (id) => {
        const params = { limit: limit, page: page }

        dispatch(deleteFaq({ id }, (res) => {
            dispatch(faqList(params, (res) => { }))
        }))

        // setRows(rows.cfilter((row) => row.id !== id));
    };

    const handleCancelClick = (id) => {
        setRowModesModel({
            ...rowModesModel,
            [id]: { mode: GridRowModes.View, ignoreModifications: true },
        });

        const editedRow = rows.find((row) => row.id === id);
        if (editedRow.isNew) {
            setRows(faq.list.filter((row) => row.id !== id));
        }
    };

    const processRowUpdate = (newRow) => {
        const updatedRow = { ...newRow, isNew: false };
        setRows(faq.list.map((row) => (row.id === newRow.id ? updatedRow : row)));

        var editedRow = faq.list.find((row) => row.id === newRow.id)
        if (editedRow) {
            dispatch(
                editFaq({ id: newRow.id, question: newRow.question, answer: newRow.answer }, (res) => {
                    const params = { page: page, limit: limit }

                    dispatch(
                        faqList(params, (res) => { }),
                    )
                }),
            )
        }
        else {
            dispatch(
                addFaq({ question: newRow.question, answer: newRow.answer }, (res) => {
                    const params = { page: page, limit: limit }

                    dispatch(
                        faqList(params, (res) => { }),
                    )
                }),
            )
        }


        return updatedRow;
    };

    const handleRowModesModelChange = (newRowModesModel) => {
        setRowModesModel(newRowModesModel);
    };

    function CustomEditComponent(props) {

        const { id, value, field, hasFocus } = props;
        const apiRef = useGridApiContext();
        const ref = React.useRef();

        React.useLayoutEffect(() => {
            if (hasFocus) {
                ref.current.focus();
            }
        }, [hasFocus]);

        const handleValueChange = (event) => {
            const newValue = event.target.value; // The new value entered by the user
            apiRef.current.setEditCellValue({ id, field, value: newValue });
        };
        return <span style={{ width: "100%" }}><textarea style={{ width: "100%" }} ref={ref} rows={8} type="text" onChange={handleValueChange} value={props.value}  ></textarea></span>;
    }




    const columns = [
        {
            field: 'question', renderEditCell: (params) => (
                <CustomEditComponent {...params} />
            ), headerName: 'Question', width: 300, editable: true
        },
        {
            field: 'answer',
            renderEditCell: (params) => (
                <CustomEditComponent {...params} />
            ),
            width: 400, headerName: 'Answer', editable: true
        },
        // if(filter == 1) {
        // { field: 'name',  headerName: 'Name', width: 300, editable: true },
        // { field: 'name', headerName: 'Name', width: 300, editable: true },
        // }
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            width: 100,
            cellClassName: 'actions',
            getActions: ({ id }) => {
                const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

                if (isInEditMode) {
                    return [
                        <GridActionsCellItem
                            icon={<SaveIcon />}
                            label="Save"
                            sx={{
                                color: 'primary.main',
                            }}
                            onClick={() => handleSaveClick(id)}
                        />,
                        <GridActionsCellItem
                            icon={<CancelIcon />}
                            label="Cancel"
                            className="textPrimary"
                            onClick={() => handleCancelClick(id)}
                            color="inherit"
                        />,
                    ];
                }

                return [
                    <GridActionsCellItem
                        icon={<EditIcon />}
                        label="Edit"
                        className="textPrimary"
                        onClick={() => handleEditClick(id)}
                        color="inherit"
                    />,
                    <GridActionsCellItem
                        icon={<DeleteIcon />}
                        label="Delete"
                        onClick={() => handleDeleteClick(id)}
                        color="inherit"
                    />,
                ];
            },
        },
    ];

    return (
        <div className="userPage adminPage merchantlist ">
            <Loader loading={loaders.isFetching} />

            {/* <div className="scroll-fix"> */}
            <Grid container spacing={1}>
                <Grid item xs={12} sm={6} md={8}>
                    <div style={{ display: 'flex' }}>
                        <div>
                            <p className="headinguser">FAQ's</p>
                            {/* <p className="subheadinggraph">
                    Merchant of Climate Mobility & Safety
                  </p> */}
                        </div>
                    </div>
                </Grid>

            </Grid>
            <div className="pagination-settings">
                <div className="pagination">
                    <p>
                        Showing {faq.list.length} out of {faq.total_users}
                    </p>
                </div>

                <Stack spacing={2}>
                    <Pagination
                        count={Math.ceil(faq.total_users / limit)}
                        page={page}
                        onChange={(e, value) => setNewPage(value)}
                        color="primary"
                    />
                </Stack>
                <div className="pagination2">
                    <p>Rows Per Page</p>
                    <select className='pagination-select' onChange={(e) => updatePagination(e)}>
                        <option selected={limit == 5}>5</option>
                        <option selected={limit == 10}>10</option>
                        <option selected={limit == 20}>20</option>
                    </select>
                </div>
            </div>
            <Box
                className="faq"
                sx={{
                    height: 500,
                    marginTop: "10px",
                    width: '100%',
                    '& .actions': {
                        color: 'text.secondary',
                    },
                    '& .textPrimary': {
                        color: 'text.primary',
                    },
                }}
            >

                <DataGrid
                    rows={rows}
                    columns={columns}
                    editMode="row"
                    rowModesModel={rowModesModel}
                    onRowModesModelChange={handleRowModesModelChange}
                    onRowEditStop={handleRowEditStop}
                    processRowUpdate={processRowUpdate}
                    slots={{
                        toolbar: EditToolbar,
                    }}
                    slotProps={{
                        toolbar: { setRows, setRowModesModel, faq },
                    }}
                />
            </Box>
        </div>
        // </div>

    );
}

export default FAQ
